export type VisualOperationType =
  | 'material_swap'
  | 'node_visibility'
  | 'variant_switch'
  | 'geometry_parameter'
  | 'camera_preset'
  | 'annotation';

export interface VisualTarget {
  targetType: 'node' | 'material_slot' | 'variant_set' | 'camera' | 'annotation';
  targetId: string;
}

export interface VisualMappingRule {
  id: string;
  when: {
    attributeId?: string;
    componentId?: string;
    value?: unknown;
  };
  apply: {
    operation: VisualOperationType;
    target: VisualTarget;
    value: unknown;
  };
}
